var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-data-table",class:[
    _vm.dataTableClass,
    {
      'sticky-header': _vm.stickyHeader,
      'moveable-row': _vm.moveRows,
    },
  ]})
}
var staticRenderFns = []

export { render, staticRenderFns }